<div class="item" *ngIf="!data.IsPurchasedVelocity && !data.isBillingBrackDown">
    <div class="grid-row item_group">
        <label class="item_label">Warehouse Name</label>
        <label class="item_label">Total Pieces</label>
    </div>
    <div class="grid-row item_group" *ngFor="let item of warehouseList">
        <span class="purchase-order item_value">{{item.warehouse}}</span>
        <span class="item_value">{{item.piesces}}</span>
    </div>
    <div class="item_footer border-top pt-1 mt-2 item_group">
        <span>Reserved</span>
        <span>{{reserved}}</span>
    </div>
</div>

<div class="item" *ngIf="data.IsPurchasedVelocity && !data.isBillingBrackDown">
    <div class="grid-row item_group">
        <span></span>
        <label class="item_label">Pre Season</label>
        <label class="item_label">Season</label>
        <label class="item_label">Pct Change</label>
    </div>
    <div class="grid-row item_group">
        <label class="item_label">Last Year:</label>
        <span class="purchase-order item_value" [matTooltip]="data.Velocity90_1yr">{{data.Velocity90_1yr | number: "1.0-2" }}</span>
        <span class="item_value" [matTooltip]="data.PurchaseDayVel1yr">{{data.PurchaseDayVel1yr | number: "1.0-2" }}</span>
        <span class="item_value" [matTooltip]="data.PctChange1Yr">{{data.PctChange1Yr | number: "1.0-2" }}</span>
    </div>
    <div class="grid-row item_group">
        <label class="item_label">2 Years Ago: </label>
        <span class="purchase-order item_value" [matTooltip]="data.Velocity90Days2yr">{{data.Velocity90Days2yr | number: "1.0-2" }}</span>
        <span class="item_value" [matTooltip]="data.PurchaseDayVel2yr">{{data.PurchaseDayVel2yr | number: "1.0-2" }}</span>
        <span class="item_value" [matTooltip]="data.PctChange2Yr">{{data.PctChange2Yr | number: "1.0-2" }}</span>
    </div>
</div>

<div class="item warehouseTooltip" *ngIf="data.isBillingBrackDown">
    <div *ngFor="let item of breakDown">
        <div class="grid-row item_group">
            <label class="item_label font-12">{{item.productName}}</label>
            <span class="purchase-order item_value font-12"><span class="column">:</span>$ {{item.total | number: "1.0-2"}}</span>
        </div>
    </div>
</div>
